import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ProjectService } from '../../shared/services/project.service';
import { Subject } from 'rxjs';
import {finalize, takeUntil} from 'rxjs/operators';
import {LoadingItem} from "../../shared/interfaces/loading-item";
import {LoadingService} from "../../shared/services/loading.service";

@Injectable({
  providedIn: 'root'
})
export class PriceService implements OnDestroy {
  private unsubscribe$ = new Subject();

  constructor(
    private _http: HttpClient,
    private _projectService: ProjectService,
    private _loadingService: LoadingService
  ) { 
    
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }


  public getLivePrice(product: any): Promise<any> {
    const { id, tourCustom, productType } = product;

    return new Promise((resolve, reject) => {
      const body = {
        pricePerPerson: true,
        productId : productType.id === 3 ? tourCustom : id,
        productType: productType.id
      }
      this._projectService.getAgencyApikey().pipe(takeUntil(this.unsubscribe$)).subscribe(apiKey => {
        const loadingItem: LoadingItem = { id: 'product-live-price', message: 'Stiamo recuperando le migliori offerte da mostrarti...' };
        const api = `${environment.site}${apiKey}/productLivePrice`;
        this._loadingService.addLoad(loadingItem);
        this._http.post(api, body)
            .pipe(finalize(() => this._loadingService.removeLoad(loadingItem)))
            .subscribe((price: any) => {
              if (price) {
                if (price.error || !price.result.price) {
                  reject("Price not available");
                } else {
                  resolve(Math.round(price.result.price));
                }
              } else {
                reject("Price not available");
              }
            });
      });
    });
  }
}
